export default from './UserImage';



// WEBPACK FOOTER //
// ./src/sharedComponents/UserImage/index.js